<div class="section-card" [ngClass]="cssClass" [ngStyle]="{'width': cardWidth}">
  <div class="section-card__title">
    {{ title }}
    <div class="d-flex align-items-center justify-content-end">
      <ng-content select="[slot='trailing-icon']"></ng-content>
      @if(enableToggle){
        <ng-container>
          <img src="assets/icons/icons-alt/chevron_down_white.svg" alt="Chevron down"
               [style.transform]="isExpanded ? 'rotate(180deg)' : 'rotate(0deg)'"
               style="transition: transform 0.3s ease;" (click)="toggleSection()" [class.cursor-pointer]="enableToggle">
        </ng-container>
      }

    </div>
  </div>
  <div class="content-box" [@slideUpDown]="isExpanded ? 'expanded' : 'collapsed'"
       [ngStyle]="{'background-color': backgroundColor || 'var(--grey-neutral-50)'}">
    <ng-content></ng-content>
  </div>
</div>
